<template>    
        <div class="layout-flex">
            <div class="main-container main-flex">
                <div class="main-content">
                    <a-breadcrumb class="breadcrumb-alertas">
                            <a-breadcrumb-item v-if="url" @click.native="regresar" style="cursor:pointer;">Regresar</a-breadcrumb-item>
                            <a-breadcrumb-item>{{ estaPagina }}</a-breadcrumb-item>
                    </a-breadcrumb>
                    <div v-if="showSemaforo" class="semaforo-float">
                        <SemaforoConAlertas :tituloAlerta="nombreAlerta" :mostrar="show" :semaforo="showSemaforo" />
                    </div>
                    <slot name="contenido"></slot>
                </div>
            </div>
        <!-- <SemaforoConAlertas :tituloAlerta="nombreAlerta" :mostrar="show" :semaforo="showSemaforo" /> -->
      
        
        <div class="sidebar alertas">
            <div class="text-center encabezado">
                <img src="images/LOGO.png" width="100%" alt="">
                <a-icon type="warning" theme="twoTone" two-tone-color="#B0261B" />
                <p class="mt-5 p-5">{{ nombreAlerta }}</p>
                <slot name="botones"></slot>
            </div>
            <div v-if="$store.state.loading" class="text-center">
                <b-spinner label="Spinning" variant="secondary"></b-spinner>
            </div>
            <div class="text-center p-5 contenedor" v-else>

                <div class="scrollable" v-if="$store.state.alertas.length > 0">
                    <ul class="estilos-lista">
                        <li v-for="alerta, index in $store.state.alertas" :key="index" class="text-sm"><strong>{{ alerta.timestamp }}:</strong> Equipo con CBI {{ alerta.cbi }} presenta novedad, {{ alerta.detalle_alerta }} <br><span class=""><strong>UBICACION:</strong> {{ alerta.mcpio }}/ {{ alerta.nombre }}/ {{ alerta.bloque_edificio }}/ {{ alerta.area_especifica }}</span></li>
                    </ul>
                </div>
                <div v-else>
                    <a-alert message="No hay alertas que mostrar" type="info" />
                    <!-- <button class="btn btn-success" @click="enviarJSON">Enviar JSON</button> -->
                </div>
            </div>    
            <div class="text-center position-absolute bottom-0 end-0">
                <img src="images/logo_blanco.png" width="70%" alt="">
            </div>
        </div>
    </div>
</template>
<script>
    import SemaforoConAlertas from '@/components/Semaforo/SemaforoConAlertas.vue';
    import Loading from '@/components/Loader/Loading.vue';
    import axios from 'axios';
    export default {
        props: ['nombreAlerta', 'show', 'showSemaforo', 'url', 'estaPagina'],
        components: {
            SemaforoConAlertas, Loading
        },
        data(){
            return{
            }
        },
        mounted() {
        },
        methods: {
            enviarJSON(){

                /* const JSON = {
                    "body": "{\"CBI\":\"16550405322\",\"estado\":\"ON\",\"timestamp\":\"2025-09-29T8:43:23\",\"unidad_exterior\":{\"voltaje\":126.1,\"corriente\":0.716,\"potencia\":45.5,\"fp\":0.6,\"frecuencia\":60},\"unidad_interior\":{\"voltaje\":225,\"corriente\":0,\"potencia\":0,\"fp\":0,\"frecuencia\":0,\"temperatura_ds18b20\":19.0625},\"ambiente\":{\"temperatura\":25.2,\"humedad\":61.8},\"potencia_total\":46.7,\"energia_total\":0.153}"
                } */

                const JSON = {"body":"{\"CBI\":\"16550433871\",\"estado\":\"ON\",\"timestamp\":\"2025-11-17T17:25:39\",\"wifi_config_version\":1,\"unidad_exterior\":{\"voltaje\":222.3,\"corriente\":8.357,\"potencia\":1843.8,\"fp\":0.99,\"frecuencia\":59.9},\"unidad_interior\":{\"voltaje\":222.2,\"corriente\":7.49,\"potencia\":45.2,\"fp\":0.99,\"frecuencia\":60,\"temperatura_ds18b20\":20.375},\"ambiente\":{\"temperatura\":28.8,\"humedad\":74.7},\"potencia_total\":0,\"energia_total\":0}"}

                
                axios.post('https://apienerhvac.unisinu.edu.co/api/lecturas', JSON, {
                    headers: {
                        "Content-Type": "application/json",
                        "api_key": "S1N4RQ20253N3RV4"
                    }
                })
                .then(res => console.log(res.data))
                .catch(err => console.log(err))
            },
            inicio(){
                this.$router.push('/inicio')
            },
            regresar(){
                if(this.url === null){
                    this.$router.push({path: this.$store.state.prevRoute})
                    return
                }
                this.$router.push({path: this.url})
            }
        },
    }
</script>
<style scoped>

.layout-flex {
    display: flex;
    flex-direction: row;
    height: 100vh;
    overflow: hidden;
}

.main-flex {
    display: flex;
    flex-direction: column;
    height: 100vh;
    min-width: 0;
    max-width: 100%;
    background: #fff;
}

.main-container {
    flex: 1;
    min-width: 0;
    box-sizing: border-box;
    background: #fff;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.main-content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-height: 0;
    padding: 0;
    position: relative;
}

.main-content > .breadcrumb-alertas {
    flex-shrink: 0;
    padding: 12px 1rem;  /* Reducir padding lateral del breadcrumb */
    margin: 0;
}

.main-content > :last-child {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 0 1rem 1rem 1rem;  /* Reducir padding lateral del contenido */
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* Asegurar que el contenido del slot use toda la altura */
.main-content > :last-child > * {
    flex: 1;
    min-height: 0;
    width: 100%;
    height: 100%;
}

/* Ajustes específicos para mapas SVG */
.main-content :deep(.svg-container) {
    height: 100% !important;
    width: 100% !important;
    max-height: none !important;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.main-content :deep(.svg-container svg) {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    display: block;
}

/* Estilos específicos para SVG directo (como Monteria) */
.main-content :deep(.svg-image) {
    width: 100% !important;
    height: 100% !important;
    max-width: 100%;
    max-height: 100%;
    display: block;
    object-fit: contain;
}

.sidebar.alertas {
    /* min-width: 280px; */
    background: #3a4958;
    color: #fff;
    box-shadow: -2px 0 16px rgba(0,0,0,0.08);
    /* flex-shrink: 0; */
    overflow-y: auto;
    /* margin-right: 24px; */
}

@media (max-width: 900px) {
    .sidebar.alertas {
        width: 100vw;
        min-width: 0;
        position: fixed;
        right: 0;
        top: 0;
        z-index: 100;
        height: 100vh;
        box-shadow: none;
    }
    .layout-flex {
        flex-direction: column;
    }
    .semaforo-float {
        top: 10px;
        right: 10px;
        z-index: 101;
    }
}
.breadcrumb-alertas {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    flex-shrink: 0;
}

.semaforo-float {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 100;
    pointer-events: none;
}

.semaforo-float > * {
    pointer-events: auto;
}

/* Estilos personalizados para breadcrumb */
.breadcrumb-alertas :deep(.ant-breadcrumb) {
    font-size: 14px;
    line-height: 1.5;
}

.breadcrumb-alertas :deep(.ant-breadcrumb-separator) {
    color: #8c8c8c;
    margin: 0 8px;
}

.breadcrumb-alertas :deep(.ant-breadcrumb-link) {
    color: #8c8c8c;
    text-decoration: none;
    transition: color 0.3s ease;
}

.breadcrumb-alertas :deep(.ant-breadcrumb-link:hover) {
    color: #475564;
}

.breadcrumb-alertas :deep(.ant-breadcrumb > span:last-child .ant-breadcrumb-link) {
    color: #475564;
    font-weight: 600;
}

.breadcrumb-alertas :deep(.ant-breadcrumb > span:first-child .ant-breadcrumb-link) {
    color: #1890ff;
    cursor: pointer;
}

.breadcrumb-alertas :deep(.ant-breadcrumb > span:first-child .ant-breadcrumb-link:hover) {
    color: #40a9ff;
    text-decoration: underline;
}

/* === OPTIMIZACIONES RESPONSIVAS PARA MEJOR USO DEL ANCHO === */
@media (min-width: 1200px) {
    .main-content > .breadcrumb-alertas {
        padding: 12px 0.5rem;  /* Menos padding en pantallas grandes */
    }
    
    .main-content > :last-child {
        padding: 0 0.5rem 1rem 0.5rem;  /* Menos padding lateral */
    }
}

@media (min-width: 1400px) {
    .main-content > .breadcrumb-alertas {
        padding: 12px 0.25rem;  /* Padding mínimo en pantallas XL */
    }
    
    .main-content > :last-child {
        padding: 0 0.25rem 1rem 0.25rem;  /* Padding lateral mínimo */
    }
}

@media (min-width: 1600px) {
    .main-content > .breadcrumb-alertas {
        padding: 12px 0;  /* Sin padding lateral en pantallas XXL */
    }
    
    .main-content > :last-child {
        padding: 0 0 1rem 0;  /* Sin padding lateral */
    }
}
</style>